import { useEffect, useState } from 'react'
import { useCQuery, invalidateQuery } from '../../../Services/QueryCache'
import { FC } from '../../../Services/FeathersClient'

export const useFornitore = (fornitoreId) => {
  const [fornitore, setFornitore] = useState()
  const { data, isSuccess } = useCQuery(['fornitore', fornitoreId])

  useEffect(() => {
    isSuccess && setFornitore(data)
  }, [isSuccess, data])

  const setFornitoreProp = (prop, value) =>
    setFornitore({ ...fornitore, [prop]: value })

  return [fornitore, setFornitoreProp, isSuccess]
}

export const saveFornitore = async (fornitore) => {
  if (fornitore.id === 'new') {
    delete fornitore.id
    try {
      const res = await FC.service('fornitori').create({ ...fornitore })
      invalidateQuery(['fornitore', 'fornitori'])
      window.growl.show({ severity: 'success', summary: 'Success', detail: 'Salvataggio effettuato' })
      return res
    } catch (e) {
      window.growl.show({ severity: 'error', summary: 'Errore', detail: 'Errore Salvataggio' })
      return false
    }
  }
  try {
    const res = await FC.service('fornitori').patch(fornitore.id, fornitore)
    invalidateQuery(['fornitore', 'fornitori'])
    window.growl.show({ severity: 'success', summary: 'Success', detail: 'Salvataggio effettuato' })
    return res
  } catch (e) {
    window.growl.show({ severity: 'error', summary: 'Errore', detail: 'Errore Salvataggio' })
    return false
  }
}

export const deleteService = async (fornitoreId) => {
  const res = await FC.service('fornitori').remove(fornitoreId)
  invalidateQuery(['fornitore', 'fornitori'])
  window.growl.show({ severity: 'success', summary: 'Success', detail: 'Eliminazione effettuata' })
  return res
}
